<template>
  <el-card body-style="padding:0px 20px" shadow="never">
    <h3 class="common-title mb10">附件</h3>
    <div class="card-content" style="padding: 0 0px 20px;">
      <p :class="[hasNotValueFields.includes('附件') ? 'warning-text' : '', 'propject_detail_info_title']">
        附件信息<a class="text-btn" @click="beforeUpload"> <i class="el-icon-circle-plus" /> </a>
      </p>
    </div>

    <div class="card-content" style="padding: 0 0px 20px;">
      <!-- <p class="propject_detail_info_title">
        附件 <a class="text-btn" @click="beforeUpload"> <i class="el-icon-circle-plus" /> </a>
      </p> -->
      <table v-if="project.附件 && project.附件.length > 0" class="hr" style="width:100%">
        <thead>
          <td>类型</td>
          <td>文件名</td>
          <td>上传人</td>
          <td>操作</td>
        </thead>
        <tbody>
          <tr v-for="item in project.附件" :key="item._id">
            <td>{{ item['type'] }}</td>
            <td @click="preview(item)">
              <span class="text-btn">{{ item['originalname'] }}</span>
            </td>
            <td>{{ Array.isArray(item['uploader']) ? item['uploader'].join('、') : item['uploader'] }}</td>
            <td @click="removeAtta(item)"><span class="text-btn warning-text">删除</span></td>
          </tr>
        </tbody>
      </table>
    </div>

    <el-dialog title="附件上传" :visible.sync="dialogVisible" :close-on-click-modal="false" :modal="false">
      <el-select v-model="fileType" filterable placeholder="请选择文件类型">
        <el-option v-for="item in projectFileTypes" :key="item" :label="item" :value="item" />
      </el-select>
      <span slot="footer" class="dialog-footer">
        <span class="mr10"> <el-button size="mini" type="danger" @click="onCancel">取 消</el-button> </span>
        <el-button size="mini" type="primary" @click="upload()">下一步</el-button>
      </span>
    </el-dialog>
    <UploadDialog ref="upload" :on-success="uploadSuccess" :type="fileType" :label="fileType" />
  </el-card>
</template>
<script>
import { projectFileTypes } from '../../constant/type'
import { defaultProject, defaultCompany } from '../../constant/defaultData'

export default {
  props: {
    project: { type: Object, default: () => window._.cloneDeep(defaultProject) },
    company: { type: Object, default: () => window._.cloneDeep(defaultCompany) },
    hasNotValueFields: { type: Array, default: () => [] },
  },
  data() {
    return {
      dialogVisible: false,
      fileType: '',
    }
  },
  computed: {
    projectFileTypes() {
      return projectFileTypes
    },
  },
  methods: {
    async removeAtta(item) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await app.service('project').removeProjectFile(item._id)
          if (res.status === 'success') {
            this.project.附件 = this.project.附件.filter(v => v._id !== item._id)
            this.$message.success('删除成功')
          }
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    async preview(file) {
      const ref = app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
    beforeUpload() {
      this.dialogVisible = true
      this.fileType = ''
    },
    onCancel() {
      this.dialogVisible = false
    },
    upload() {
      this.$refs.upload.visible(true)
    },
    async uploadSuccess(response, file, fileList) {
      this.$refs.upload.visible()
      const res = response[0]
      try {
        await window.app.service('project').insertProjectFile([
          Object.assign(res, {
            type: this.fileType || '附件',
            projectId: this.project._id,
          }),
        ])
        this.getProjectFiles(this.project._id)
        this.$message.success(`上传成功`)
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async getProjectFiles(projectId) {
      if (!projectId) return (this.project.附件 = [])
      this.filesLoading = true
      try {
        const { data } = await window.app.service('file').projectFiles({ query: { projectId } })
        this.project.附件 = data
      } catch (e) {
        console.error(e)
      }
      this.filesLoading = false
    },
  },
}
</script>
<style scoped src="../../css/newProjectDetail.css"></style>
<style scoped>
.hr{
  overflow:auto;
}
</style>
